<template>
  <div>
    <div class="banner">
      <div class="title wow animate__animated durationTime animate__fadeInUp">无线校园</div>
      <div class="desc wow animate__animated durationTime animate__fadeInUp">柠檬网联专注职教校园市场10年，针对校园宿舍场景量身打造无线校园<br>
        网络一体化创新解决方案，创新推出BOO模式，可享受先收益后投资。
      </div>
    </div>
    <div class="wl-solution" id="wl-solution">
      <div class="title">专注校园市场，推出创新整合方案    <self-video v-if="showVideoState" @closeVideo="handleCloseVideo" :message="video"></self-video></div>
      <div class="nav">
          <div class="nav-con">
            <div :class="['nav-con-title cus-pointer',activeWlSolutionTitle==='市场需求痛点'?'nav-con-title-active':'']" @click="updateWlSolutionTitle('市场需求痛点')">市场需求痛点</div>
            <div :class="['nav-con-title cus-pointer',activeWlSolutionTitle==='创新解决方案'?'nav-con-title-active':'']" @click="updateWlSolutionTitle('创新解决方案')">创新解决方案</div>
            <div :class="['nav-con-title cus-pointer',activeWlSolutionTitle==='创新运营模式'?'nav-con-title-active':'']" @click="updateWlSolutionTitle('创新运营模式')">创新运营模式</div>
            <div :class="['nav-con-title cus-pointer',activeWlSolutionTitle==='创新合作模式'?'nav-con-title-active':'']" @click="updateWlSolutionTitle('创新合作模式')">创新合作模式</div>
          </div>
        </div>
      <div class="content wow animate__animated durationTime animate__slideInLeft" style="display: flex;margin-top: 0.4rem;justify-content: space-between">
        <div class="first-img solution-pre"  :style="{
              backgroundImage: `url(${require(`@/assets/${wlSolutionActive[0].img}`)})`,
            }">
          <div @click="getSolutionPreThree(wlSolutionActive[0].title)" class="right">
          </div>
        </div>
        <div class="second-img solution-active "  @click="showVideo(wlSolutionActive[1].showVideo)" :style="{
              backgroundImage: `url(${require(`@/assets/${wlSolutionActive[1].img}`)})`,
            }">
          <img :src="require(`@/assets/${wlSolutionActive[1].activeImg}`)">
        </div>
        <div class="third-img solution-next"  :style="{
              backgroundImage: `url(${require(`@/assets/${wlSolutionActive[2].img}`)})`,
            }">
          <div class="left" @click="getSolutionNextThree(wlSolutionActive[2].title)"></div>
        </div>
       </div>
    </div>
    <div class="wl-spec" id="wl-spec">
       <div class="nav" ref="nav" style=" position: sticky;top:0;z-index: 889;height: 0.88rem">
         <div class="nav-con">
           <div :class="['nav-con-title cus-pointer',activeWlSpecTitle==='视频介绍'?'nav-con-title-active':'']" @click="updateWlSpecTitle('视频介绍','wl-solution')">视频介绍</div>
           <div :class="['nav-con-title cus-pointer',activeWlSpecTitle==='网联优势'?'nav-con-title-active':'']" @click="updateWlSpecTitle('网联优势','content-spec')">网联优势</div>
           <div :class="['nav-con-title cus-pointer',activeWlSpecTitle==='解决方案'?'nav-con-title-active':'']" @click="updateWlSpecTitle('解决方案','wl-chuangxin')">解决方案</div>
           <div :class="['nav-con-title cus-pointer',activeWlSpecTitle==='运营模式'?'nav-con-title-active':'']" @click="updateWlSpecTitle('运营模式','wl-business')">运营模式</div>
           <div :class="['nav-con-title cus-pointer',activeWlSpecTitle==='合作模式'?'nav-con-title-active':'']" @click="updateWlSpecTitle('合作模式','content-mode')">合作模式</div>
           <div :class="['nav-con-title cus-pointer',activeWlSpecTitle==='特色产品'?'nav-con-title-active':'']" @click="updateWlSpecTitle('特色产品','content-product')">特色产品</div>
           <div :class="['nav-con-title cus-pointer',activeWlSpecTitle==='全国覆盖'?'nav-con-title-active':'']" @click="updateWlSpecTitle('全国覆盖','managingPatientSize')">全国覆盖</div>
           <div :class="['nav-con-title cus-pointer',activeWlSpecTitle==='客户案例'?'nav-con-title-active':'']" @click="updateWlSpecTitle('客户案例','customer-tab')">客户案例</div>
           </div>
       </div>
       <div class="content-spec" id="content-spec">
         <div class="title wow animate__animated durationTime animate__fadeInUp">为什么选择网联？</div>
         <div class="line">
           <div class="left wow animate__animated durationTime animate__slideInLeft">
             <div class="one"><img src="../../assets/image/wireless/icon1.png" style="width:0.3rem;margin-right: 0.1rem">垂直职教校园市场十年</div>
             <div class="two">因为专注，所以专业</div>
           </div>
           <img  src="../../assets/image/wireless/wx-spec-zhuanye.png"/>
           <div class="right wow animate__animated durationTime animate__slideInRight">
             <div class="one">已成功上线上千个项目<img src="../../assets/image/wireless/icon2.png" style="width:0.2737rem;margin-left: 0.1rem"></div>
             <div class="two">多数人的选择，所以值得放心</div>
           </div>
         </div>
         <div style="text-align: center"> <img style="height: 0.58rem" src="../../assets/image/wireless/spec-icon1.png"></div>
         <div class="line">
           <div class="left wow animate__animated durationTime animate__slideInLeft">
             <div class="one"><img src="../../assets/image/wireless/icon3.png" style="width:0.3rem;margin-right: 0.1rem">PSE技术</div>
             <div class="two">国家级专利技术，大幅降低网线及设备施工成本</div>
           </div>
           <img  src="../../assets/image/wireless/wx-spec-shengqian.png"/>
           <div class="right wow animate__animated durationTime animate__slideInRight">
             <div class="one">设备自研<img src="../../assets/image/wireless/icon4.png" style="width:0.2582rem;margin-left: 0.1rem"></div>
             <div class="two">自研全套软硬件产品，设备成本显著低于品牌厂商</div>
           </div>
         </div>
         <div style="text-align: center"> <img style="height: 0.58rem" src="../../assets/image/wireless/spec-icon2.png"></div>
         <div class="line">
           <div class="left wow animate__animated durationTime animate__slideInLeft">
             <div class="one"><img src="../../assets/image/wireless/icon5.png" style="width:0.3rem;margin-right: 0.1rem">一站式服务</div>
             <div class="two">一整套专业执行标准和高效执行能力</div>
           </div>
           <img  src="../../assets/image/wireless/wx-spec-shengxin.png"/>
           <div class="right wow animate__animated durationTime animate__slideInRight">
             <div class="one">软件一体化<img src="../../assets/image/wireless/icon6.png" style="width:0.3rem;margin-left: 0.1rem"></div>
             <div class="two">云认证计费系统功能高度集成，即开即用</div>
           </div>
         </div>
         <div style="text-align: center"> <img style="height: 0.58rem" src="../../assets/image/wireless/spec-icon1.png"></div>
         <div class="line">
           <div class="left wow animate__animated durationTime animate__slideInLeft">
             <div class="one"><img src="../../assets/image/wireless/icon7.png" style="width:0.3rem;margin-right: 0.1rem">回收周期短</div>
             <div class="two">一次投入，一年回本</div>
           </div>
           <img  src="../../assets/image/wireless/wx-spec-zhuanqian.png"/>
           <div class="right wow animate__animated durationTime animate__slideInRight">
             <div class="one">高回报率<img src="../../assets/image/wireless/icon8.png" style="width:0.1693rem;margin-left: 0.1rem"></div>
             <div class="two">五年投资回报率400%</div>
           </div>
         </div>
       </div>
      <div class="wl-chuangxin" id="wl-chuangxin">
        <div class="title">创新的解决方案</div>
        <div class="box">
          <div class="det">
            <div class="top">
              <div style="text-align: center;margin-bottom: 0.2rem"> <img style="width: 0.38rem" src="../../assets/image/wireless/lightLogo.png"></div>

              <div class="title">一站式服务</div>
            </div>
            <div class="bot">
              <div class="title">一站式服务</div>
              <div class="desc">柠檬网联无线校园解决方案是专为学校信息化建设打造的一整套、全方位的创新型解决方案，通过为学校提供专业的规、建、营、维一体化服务，解决了校园无线网络组网方案组合拼接的烦恼，建设成本低至品牌厂商1/3，全方位满足合作方、校方需求。</div>
            </div>
          </div>
          <div class="det">
            <div class="top">
              <div style="text-align: center;margin-bottom: 0.2rem"> <img style="width: 0.38rem" src="../../assets/image/wireless/lightLogo.png"></div>
              <div class="title">高性价比自研设备</div>
            </div>
            <div class="bot">
              <div class="title">高性价比自研设备</div>
              <div class="desc">公司自研适用于校园全场景的高性能无线网络设备，兼容以太网与全光网组网方案，无线AP设备拥有PSE供电发明专利，能够降低30%的网线与施工成本，专利产品赢得了广泛的市场认可与用户好评。</div>
            </div>
          </div>
          <div class="det">
            <div class="top">
              <div style="text-align: center;margin-bottom: 0.2rem"> <img style="width: 0.38rem" src="../../assets/image/wireless/lightLogo.png"></div>
              <div class="title">软件一体化</div>
            </div>
            <div class="bot">
              <div class="title">软件一体化</div>
              <div class="desc">云认证计费系统同时兼具功能强大、集成度高、即开即用等优点，支持多种计费运营模式，有效提升校园无线网络用户转化率，同时还能兼容多家主流厂商设备，无缝接管学校现有其他厂商平台，实现全面自主运营。</div>
            </div>
          </div>
          <div class="det">
            <div class="top">
              <div style="text-align: center;margin-bottom: 0.2rem"> <img style="width: 0.38rem" src="../../assets/image/wireless/lightLogo.png"></div>
              <div class="title">创新防共享机制</div>
            </div>
            <div class="bot">
              <div class="title">创新防共享机制</div>
              <div class="desc">创新型防共享机制，实现“一校一网，一人一账号“，杜绝用户蹭网，有效解决校园无线网络安全问题，使校园无线网络更加合规化、安全化。</div>
            </div>
          </div>
        </div>
      </div>
      <div class="wl-business"  id="wl-business">
        <div class="title wow animate__animated durationTime animate__fadeInUp">多种运营模式覆盖全场景</div>
        <div class="nav1">
          <div class="nav-con">
            <div :class="['nav-con-title cus-pointer',activeWlBusinessTitle==='用户付费模式'?'nav-con-title-active':'']" @click="updateWlBusinessTitle('用户付费模式')">用户付费模式</div>
            <div :class="['nav-con-title cus-pointer',activeWlBusinessTitle==='融合套餐模式'?'nav-con-title-active':'']" @click="updateWlBusinessTitle('融合套餐模式')">融合套餐模式</div>
            <div :class="['nav-con-title cus-pointer',activeWlBusinessTitle==='更多创新运营模式'?'nav-con-title-active':'']" @click="updateWlBusinessTitle('更多创新运营模式')">更多创新运营模式</div>
          </div>
        </div>
        <div class="content">
          <div class="top">
            <div class="left" style="">
              <div class="title wow animate__animated durationTime animate__fadeInUp">{{businessInfo.title}}</div>
              <div class="desc wow animate__animated durationTime animate__fadeInUp">{{businessInfo.desc}}</div>
              <div class="point-con-list wow animate__animated durationTime animate__fadeInUp">
                <div class="con"  style="" v-for="(item,index) in businessInfo.point">
                  <div class="icon" style=""></div>
                  <div class="text">
                    <span class="title1" style="">{{item.title}}</span>
                    <span class="desc1">{{item.desc}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="right wow animate__animated durationTime animate__fadeInUp" style="">
              <img :src="require(`@/assets/${businessInfo.img}`)" style="height: 80%;"/>
            </div>

          </div>
          <div class="bot">
            <div class="line1 wow animate__animated durationTime animate__fadeInUp">{{businessInfo.secondTitle}}</div>
            <div class="list">
              <div class="item wow animate__animated durationTime animate__fadeInUp" v-for="item in businessInfo.partnerList">
                <img :src="require(`@/assets/${item.smallImg}`)">
                <div class="con">
                  <div class="title">{{item.name}}</div>
                  <div class="desc">{{item.desc}}</div>
                  <div v-if="item.jump" class="more" @click="businessJump(item.id)">查看详情</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-mode" id="content-mode">
        <div class="title wow animate__animated durationTime animate__fadeInUp">三种合作模式可选，支持合作伙伴先收益后选择投资模式</div>
        <div class="secondTitle wow animate__animated durationTime animate__fadeInUp">柠檬网联提供三种投资模式，您可以选择适合您的合作方式，为您带来更高的收益与保障。</div>
        <div class="data  wow animate__animated durationTime animate__fadeInUp">
          <div class="lf">
            <div class="row1"></div>
            <div style="background: linear-gradient( 180deg, #98A6E8 0%, #2440C4 100%);">
              <div style="border-top-left-radius: 0.1rem !important;  color: #FFF !important;" class="row2 con">投资模式</div>
              <div class="row3 con">网联主投</div>
              <div class="row4 con">共投共建</div>
              <div class="row5 con">合作伙伴主投</div>
            </div>

          </div>
          <div class="mid">
            <div class="row1 he" style="border-top-left-radius: 0.1rem">投资方式</div>
            <div class="row2 con">
              <div class="par">合作伙伴</div>
              <div>网联</div>
            </div>
            <div class="row3 con">
              <div class="par">0投资</div>
              <div>
                <div>一次性投资</div>
                <div>宽带、云平台</div>
              </div>
            </div>
            <div class="row4 con">
              <div>施工</div>
              <div>
                <div>宽带、设备、</div>
                <div>云平台</div>
              </div>
            </div>
            <div class="row5 con">
              <span>一次性投资</span>
              <span>云平台</span>
            </div>
          </div>
          <div class="rg mid">
            <div class="row1 he">分工安排</div>
            <div class="row2 con">
              <div class="par">合作伙伴</div>
              <div>网联</div>
            </div>
            <div class="row3 con">
              <div>
                <div>项目签约</div>
              </div>
              <div>

                <div>全程负责执行</div>
              </div>
            </div>
            <div class="row4 con">
              <div>
                <div>项目签约+施工</div>
                <div>执行+现场维护</div>
              </div>

              <div>
                <div>宽带接入、推广运营、</div>
                <div>云维护、客服</div>
              </div>
            </div>
            <div class="row5 con">
              <span>项目签约</span>
              <div>
                <div>全程落地执行</div>
                <div>及指导支持</div>
              </div>

            </div>
          </div>
          <div class="last mid">
            <div class="row1 he" style="border-top-right-radius: 0.1rem">收入分成</div>
            <div class="row2 con" style="border-right: none">
              <div class="par">合作伙伴</div>
              <div>网联</div>
            </div>
            <div class="row3 con" style="border-right: none">
              <div>20%</div>
              <div>
                80%
              </div>
            </div>
            <div class="row4 con" style="border-right: none">
              <div>40%</div>
              <div>
                60%
              </div>
            </div>
            <div class="row5 con" style="border-right: none">
              <div>80%～90%</div>
              <div>
                <div>10～20%(平台10%</div>
                <div>+运维客服10%)</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-product" id="content-product">
        <div class="title wow animate__animated durationTime animate__fadeInUp">特色产品</div>
        <div class="box">
          <div class="vr"></div>
          <div class="product">
            <div class="hardware wow animate__animated durationTime animate__fadeInUp">
              <div class="line1">
                <div class="productLeft" @click="getHardwarePreThree"></div>
                <div class="item" v-for="item in activeHardwareProduct" @click="detail('hardware',item.id)">
                  <div class="top">
                    <span>{{item.name}}</span>
                    <img
                      style="width: 0.24rem;height: 0.24rem;margin-left: 0.1rem"
                      src="@/assets/image/index/index-product-detail.png"
                    />
                  </div>
                  <div style="text-align: center">
                    <img :src="require(`@/assets/${item.imageSrc}`)"/>
                  </div>
                </div>
                <div class="productRight" @click="getHardwareNextThree"></div>
              </div>
              <img class="cus-pointer" @click="productJump(3,'hardware')" src="https://magicwifi.ks3-cn-shanghai.ksyuncs.com/V4-video/spse.gif" style="margin-left: -0.8rem;height: 3.3415rem;margin-top: 0.8rem">

              <div class="line2 cus-pointer" @click="productJump(3,'hardware')">
                <div class="text1">PSE面板AP</div>
                <div class="text2">场景创新，发明专利，一带一级联供电，成本降低一半。</div>
              </div>
            </div>
            <div class="soft wow animate__animated durationTime animate__fadeInUp">
              <div class="line1 cus-pointer" @click="productJump(8,'soft')">
                <div class="text1">
                  云计费认证系统
                </div>
                <div class="text2">
                  云端部署，SaaS服务，即开即用，专为场景营销运营而生。
                </div>
              </div>
              <img @click="productJump(8,'soft')" class="cus-pointer" src="../../assets/image/wireless/softProductMid.jpg" style="width: 3.14rem;height: 3.35rem;margin-top: 0.89rem">
              <div class="line3">
                 <div class="productLeft" @click="getSoftPreThree"></div>
                 <div class="item" v-for="item in activeSoftProduct" @click="detail('soft',item.id)">
                   <div class="top">
                     <span>{{item.name}}</span>
                     <img
                       style="width: 0.24rem;height: 0.24rem;margin-left: 0.1rem"
                       src="@/assets/image/index/index-product-detail.png"
                     />
                   </div>
                   <div style="text-align: center">
                     <img :src="require(`@/assets/${item.imageSrc}`)"/>
                   </div>
                 </div>
                 <div class="productRight" @click="getSoftNextThree"></div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="managingPatientSize" id="managingPatientSize" >
        <div class="title wow animate__animated durationTime animate__fadeInUp">全国覆盖 为您服务</div>
        <div class="data">
          <div class="item">
            <div class="line1">
              <img src="../../assets/image/wireless/onlineMemnerIcon.png">
              <div class="number">4000</div>
              <div class="text">万+</div>
            </div>
            <div class="line2">
              覆盖用户
            </div>
          </div>
          <div class="item">
            <div class="line1">
              <img src="../../assets/image/wireless/payUserIcon.png">
              <div class="number">500</div>
              <div class="text">万+</div>
            </div>
            <div class="line2">
              付费用户
            </div>
          </div>

          <div class="item">
            <div class="line1">
              <img src="../../assets/image/wireless/partnerIcon.png">
              <div class="number">2000</div>
              <div class="text">+</div>
            </div>
            <div class="line2">
              合作伙伴
            </div>
          </div>
          <div class="item">
            <div class="line1">
              <img src="../../assets/image/wireless/schoolIcon.png">
              <div class="number">300</div>
              <div class="text">+</div>
            </div>
            <div class="line2">
              覆盖学校
            </div>
          </div>
        </div>
<!--        <div style="display: flex;justify-content: center;align-items: center">-->
<!--          <div class="hr2"></div>-->
<!--        </div>-->

        <el-row class="con wow animate__animated durationTime animate__fadeInUp">
          <el-col :span="24">
            <div id="china-map"></div>
          </el-col>
        </el-row>
      </div>
      <div id="customer-tab" style="padding-top: 0.88rem">
        <div class="customer-title wow animate__animated durationTime animate__fadeInUp">客户案例</div>
        <div class="scroll-container">
          <div class="scroll-content-wrapper">
            <div class="scroll-content">
              <img  src="../../assets/image/wireless/haierLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/bydLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/TCLlogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/dcjgLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/fskLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/geliLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/chuangweiLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/meidiLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/cahngchengLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/compalLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/zhongheLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/luxLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/shaunghui.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/jabilLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/goerLogo.png">
            </div>
            <!-- Repeating the same items for seamless scrolling -->
            <div class="scroll-content">
              <img  src="../../assets/image/wireless/haierLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/bydLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/TCLlogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/dcjgLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/fskLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/geliLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/chuangweiLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/meidiLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/cahngchengLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/compalLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/zhongheLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/luxLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/shaunghui.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/jabilLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/goerLogo.png">
            </div>
          </div>
        </div>
        <div class="scroll-container" style="margin-top: 0.2rem;margin-bottom: 1rem">
          <div class="scroll-content-wrapper-second">
            <div class="scroll-content">
              <img src="../../assets/image/wireless/ynjiLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/zhejiangligongLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/qdnyLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/gxkjLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/gdlgLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/school1Logo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/gxgyjs.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/school2Logo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/gxjdLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/hnczLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/school3Logo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/school4Logo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/school5Logo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/school6Logo.png">
            </div>
            <!-- Repeating the same items for seamless scrolling -->
            <div class="scroll-content">
              <img src="../../assets/image/wireless/ynjiLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/zhejiangligongLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/qdnyLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/gxkjLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/gdlgLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/school1Logo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/gxgyjs.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/school2Logo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/gxjdLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/hnczLogo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/school3Logo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/school4Logo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/school5Logo.png">
            </div>
            <div class="scroll-content">
              <img src="../../assets/image/wireless/school6Logo.png">
            </div>
          </div>
        </div>
      </div>

      </div>
<!--    <div class="customer-title wow animate__animated durationTime animate__fadeInUp">客户案例</div>-->
<!--    <div class="scroll-container">-->
<!--      <div class="scroll-content-wrapper">-->
<!--        <div class="scroll-content">-->
<!--          <img  src="../../assets/image/wireless/haierLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/bydLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/TCLlogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/dcjgLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/fskLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/geliLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/chuangweiLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/meidiLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/cahngchengLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/compalLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/zhongheLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/luxLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/shaunghui.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/jabilLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/goerLogo.png">-->
<!--        </div>-->
<!--        &lt;!&ndash; Repeating the same items for seamless scrolling &ndash;&gt;-->
<!--        <div class="scroll-content">-->
<!--          <img  src="../../assets/image/wireless/haierLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/bydLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/TCLlogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/dcjgLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/fskLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/geliLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/chuangweiLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/meidiLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/cahngchengLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/compalLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/zhongheLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/luxLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/shaunghui.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/jabilLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/goerLogo.png">-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="scroll-container" style="margin-top: 0.2rem;margin-bottom: 1rem">-->
<!--      <div class="scroll-content-wrapper-second">-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/ynjiLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/zhejiangligongLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/qdnyLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/gxkjLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/gdlgLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/school1Logo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/gxgyjs.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/school2Logo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/gxjdLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/hnczLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/school3Logo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/school4Logo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/school5Logo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/school6Logo.png">-->
<!--        </div>-->
<!--        &lt;!&ndash; Repeating the same items for seamless scrolling &ndash;&gt;-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/ynjiLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/zhejiangligongLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/qdnyLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/gxkjLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/gdlgLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/school1Logo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/gxgyjs.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/school2Logo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/gxjdLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/hnczLogo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/school3Logo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/school4Logo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/school5Logo.png">-->
<!--        </div>-->
<!--        <div class="scroll-content">-->
<!--          <img src="../../assets/image/wireless/school6Logo.png">-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import productData from "../product/productsData";
import businessData from './business'
import partnerData from '../partner/casesData'
import selfVideo from  './components/video'
import {backItem} from "../../util/util";
import {WOW} from "wowjs";
import index from "../index";
// 引入 ECharts 主模块
var echarts = require("echarts/lib/echarts");
// 引入柱状图
require("echarts/lib/chart/bar");
require("echarts/lib/chart/line");
// 引入提示框和标题组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
require("echarts/lib/chart/pie");
require("echarts/lib/component/markLine");
require("echarts/lib/component/geo");
require("echarts/lib/chart/scatter");
require("echarts/lib/chart/map");
export default {
  metaInfo() {
    return {
      title: '智慧校园_智能校园一体化服务_智慧校园管理定制平台_柠檬网联', // 动态标题
      meta: [
        { name: 'description', content: '柠檬网联是中国数智园区、无线网络解决方案提供商及运营服务商。历经10年发展，已经设计研发了智慧校园、智能校园一体化服务、智慧校园管理定制平台、无线网络相关一系列的软件、硬件和平台，融合物联网、大数据、云计算、人工智能等新一代信息技术，形成了以网络为基础，以数智校园、数智厂园为应用的“一体两翼”的发展格局，以网络化、数字化、智能化持续助力学校和企业园区的数字化转型升级。'}, // 动态描述
        { name: 'keywords', content: '智慧校园,智能校园一体化服务,智慧校园管理定制平台' } // 动态关键词
      ]
    };
  },
  name: "wireless",
  components:{
    selfVideo
  },
  data() {
    return {
      imgFlag: 0,
      img: '',
      activeWlSpecTitle:'网联优势',
      activeWlSolutionTitle:'市场需求痛点',
      softProduct:[],
      hardwareProduct:[
        {
          id: 1,
          name: '网关',
          imageSrc: 'image/wireless/productGw.png',
        },
        {
          id: 2,
          name: '交换机',
          imageSrc: 'image/wireless/productSw.png',
        },
        {
          id: 3,
          name: 'AP',
          imageSrc: 'image/wireless/productAp.png',
        },
        {
          id: 30,
          name: '防代理',
          imageSrc: 'image/wireless/productDl.png',
        },
      ],
      activeSoftProduct:[],
      activeHardwareProduct:[],
      currentSoftIndex:0,
      currentHardwareIndex:0,
      wlSolution:[
        {
          title:"市场需求痛点",
          img:'image/wireless/solution1.png',
          activeImg:'image/wireless/solutionActive1.png',
          showVideo:'https://wanglian-video.ks3-cn-beijing.ksyuncs.com/video/3d14e7c593a24ca1808999dc03ce3630/solu/001.mp4',
        },
        {
          title:"创新解决方案",
          img:'image/wireless/solution2.png',
          activeImg:'image/wireless/solutionActive2.png',
          showVideo:'https://wanglian-video.ks3-cn-beijing.ksyuncs.com/video/3d14e7c593a24ca1808999dc03ce3630/solu/002.mp4',
        },
        {
          title:"创新运营模式",
          img:'image/wireless/solution3.png',
          activeImg:'image/wireless/solutionActive4.png',
          showVideo:'https://wanglian-video.ks3-cn-beijing.ksyuncs.com/video/3d14e7c593a24ca1808999dc03ce3630/solu/003.mp4',
        },
        {
          title:"创新合作模式",
          img:'image/wireless/solution4.png',
          activeImg:'image/wireless/solutionActive3.png',
          showVideo:'https://wanglian-video.ks3-cn-beijing.ksyuncs.com/video/3d14e7c593a24ca1808999dc03ce3630/solu/004.mp4',
        },
      ],
      wlSolutionActive:[],
      wlSolutionCurrentIndex:3,
      activeWlBusinessTitle:'用户付费模式',
      businessInfo:null,
      video:'',
      showVideoState:false,
      isSticky: false,

    }
  },
  mounted() {

    const wow = new WOW({
      boxClass: "wow", //需要执行动画元素的Class
      animateClass: "animated_lightSpeedIn", //animation.css动画的Class
      offset: 0, //距离可视区域多少开始执行动画
      mobile: true, //是否在移动设备执行动画
      live: true ,//异步加载的内容是否有效
    });
    wow.init();
    // 延迟 500 毫秒执行
    setTimeout(() => {
      this.drawCharts();
    }, 100);
  },
  created() {
    this.$nextTick(() => {
      this.setupObservers();
    // 在DOM加载完成后执行的操作

      console.log('DOM加载完成');

    });
    this.initializeAndRun();
    this.softProduct = productData.filter(
      v => v.jump === "soft" && ['运维管理','高阶辅助'].includes(v.type) && v.id!==8
    );
    this.getSoftNextThree()
    this.getHardwareNextThree()
    this.getSolutionNextThree("市场需求痛点");
    this.updateWlBusinessTitle(this.activeWlBusinessTitle)
  },
  methods: {
    setupObservers() {
      let idsToObserve = ['wl-solution', 'content-spec', 'wl-chuangxin','content-product'];
      // idsToObserve=idsToObserve.reverse();

      idsToObserve.forEach(id => {
        const target = document.getElementById(id);
        if (target) {
          const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
              if (entry.isIntersecting && entry.boundingClientRect.top <= 200) {
                this.handleElementInView(id); // 传递元素的ID
              }
            });
          }, {
            root: null, // 使用视口作为根
            rootMargin: "400px 0px 0px 0px", // 自定义偏移量为 -200px
            threshold: 0 // 当元素可见时触发
          });

          observer.observe(target);
        }
      });
    },
    handleElementInView(id) {
      console.log(`元素 ${id} 距离屏幕顶部 200px，执行方法`);
      // 根据传入的 ID 执行你希望的操作
    },
    handleCloseVideo(){
      this.showVideoState=false;
    },
    showVideo(url){
      this.video=url;
      this.showVideoState=true;
    },
    businessJump(id){
      this.$router.push({
        name: "partnerDetail",
        query: {
          id: id
        }
      });
    },
    productJump(id,type){
      this.$router.push({
        name: type=='soft'?'productDetailSoft':'productDetail',
        query: {
          id: id
        }
      });
    },
    updateWlBusinessTitle(title){
      this.activeWlBusinessTitle=title;
      this.businessInfo=businessData.filter(v=>v.title===title)[0];
      let partnerList=[];
      this.businessInfo.jumpId.forEach((item)=>{
        partnerList.push(partnerData.filter(v=>v.id===item)[0]);
      })
      this.businessInfo.partnerList=partnerList;
      console.log( this.businessInfo)
    },
    updateWlSolutionTitle(title){
      if(title=="市场需求痛点"){
        this.wlSolutionCurrentIndex=3;
      }else if(title=="创新解决方案"){
        this.wlSolutionCurrentIndex=0;
      }else if(title=="创新运营模式"){
        this.wlSolutionCurrentIndex=1;
      }else if(title=="创新合作模式"){
        this.wlSolutionCurrentIndex=2;
      }
      this.getSolutionNextThree(title);
      this.activeWlSolutionTitle=title;
    },
    loadScript(src, id) {
      return new Promise((resolve, reject) => {
        if (document.getElementById(id)) {
          resolve(); // 如果脚本已经存在，直接resolve
          return;
        }

        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = src;
        script.id = id;

        script.onload = () => {
          resolve(); // 脚本加载成功，resolve
        };

        script.onerror = () => {
          reject(new Error(`Script load error for ${src}`)); // 脚本加载失败，reject
        };

        let s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(script, s);
      });
    },
    async initializeAndRun() {
      try {
        await this.loadScript(
          'https://material.weiling.cn/h5/willing-third-party-js/v1/qrcode-custom-comp-v1.min.js',
          'wlQRCS'
        );

        // 等待脚本加载完成后初始化
        wlQrcodeCustomComp.init({
          wl_id: 'wpW2WmDAAAsuSkpyHYrwjV4tnMu-Zjag', // [修改1：将wl_id粘贴至此]
        });

        // 初始化完成后要执行的代码
        console.log('wlQrcodeCustomComp initialized');
        // 在这里添加你需要执行的代码
        this.getCode();
      } catch (error) {
        console.error(error); // 处理加载脚本时的错误
      }
    },
    getCode() {
      wlQrcodeCustomComp.getQrCodeUrl(
        {
          wl_qrcode_id: "1801157726622015488", //  [修改1：将wl_qrcode_id粘贴至此]
        },
        (data) => {
          console.log(data); // data中包含二维码图片地址
          if (data.code == 200) {
            this.imgFlag = 1;
            this.img = data.data.qr_code;
          }
        }
      );
    },
    detail(type,id){
      if(type==='soft'){
        this.$router.push({
          name: 'productDetailSoft',
          query: {
            id: id
          }
        });
      }else if(type==='hardware'){
        this.$router.push({
          name: 'productDetail',
          query: {
            id: id
          }
        });
      }
    },
    updateWlSpecTitle(title,id){
      this.activeWlSpecTitle=title;
      backItem(id);
    },
    getSolutionNextThree(title) {
      const result = [];
      for (let i = 0; i < 3; i++) {
        result.push(this.wlSolution[(this.wlSolutionCurrentIndex + i) % this.wlSolution.length]);
      }
      this.wlSolutionCurrentIndex = (this.wlSolutionCurrentIndex + 1) % this.wlSolution.length;
      this.wlSolutionActive=result;
      this.activeWlSolutionTitle=title;
    },
    getSolutionPreThree(title) {
      const result = [];
      for (let i = 0; i < 3; i++) {
        result.push(this.wlSolution[(this.wlSolutionCurrentIndex - i + this.wlSolution.length) % this.wlSolution.length]);
      }
      this.wlSolutionCurrentIndex = (this.wlSolutionCurrentIndex - 1 + this.wlSolution.length) % this.wlSolution.length;
      this.wlSolutionActive=result.reverse();
      this.activeWlSolutionTitle=title;
    },
    getSoftNextThree() {
      const result = [];
      for (let i = 0; i < 3; i++) {
        result.push(this.softProduct[(this.currentSoftIndex + i) % this.softProduct.length]);
      }
      this.currentSoftIndex = (this.currentSoftIndex + 1) % this.softProduct.length;
      this.activeSoftProduct=result;
    },

    getSoftPreThree() {
      const result = [];
      for (let i = 0; i < 3; i++) {
        result.push(this.softProduct[(this.currentSoftIndex - i + this.softProduct.length) % this.softProduct.length]);
      }
      this.currentSoftIndex = (this.currentSoftIndex - 1 + this.softProduct.length) % this.softProduct.length;
      this.activeSoftProduct=result.reverse();
    },
    getHardwareNextThree() {
      const result = [];
      for (let i = 0; i < 3; i++) {
        result.push(this.hardwareProduct[(this.currentHardwareIndex + i) % this.hardwareProduct.length]);
      }
      this.currentHardwareIndex = (this.currentHardwareIndex + 1) % this.hardwareProduct.length;
      this.activeHardwareProduct=result;
    },
    getHardwarePreThree() {
      const result = [];
      for (let i = 0; i < 3; i++) {
        result.push(this.hardwareProduct[(this.currentHardwareIndex - i + this.hardwareProduct.length) % this.hardwareProduct.length]);
      }
      this.currentHardwareIndex = (this.currentHardwareIndex - 1 + this.hardwareProduct.length) % this.hardwareProduct.length;
      this.activeHardwareProduct=result.reverse();
    },
    drawCharts() {
      // 基于准备好的dom，初始化echarts实例
      var chinaMap = echarts.init(document.getElementById("china-map"));
      // window.onresize = chinaMap.resize; // 窗口或框架被调整大小时执行chinaMap.resize
      let option={
        tooltip: {
          backgroundColor: '#FFFFFF', // 背景颜色
          borderColor: '#FFFFFF', // 边框颜色
          textStyle: {
            color: '#333333' // 字体颜色
          },
          trigger: 'item',
          formatter: (params) => {
            let offices = [];
            let o = '';
            console.log(params.data)
            let data = params.data;
            if(data.office != undefined && data.office != null && data.office != ''){
              offices = data.office.split(",");
              if(offices.length > 0){
                o = `<div style=display:inline-block;">办事处:${offices[0]}</div>`;
              }
              offices.forEach((item, index) => {
                if(index !== 0){
                  o += `<br><div style="display:inline-block;overflow-wrap: break-word;visibility: hidden">办事处:</div><div style="display:inline-block;">${item}</div>`;
                }
              });
              console.log(offices.length);
            }

            return `<div style=" white-space: normal;border-radius: 0.7rem">${data.name}<br />项目: ${data.value}<br>${o}</div>`;
          }
        },
        geo: {
          map: "china",
          roam: false, // 禁止缩放和平移
          label: {
            normal: {
              show: true,
              textStyle: {
                color: "#333333",
              },
            },
            emphasis: {
              show: true,
              textStyle: {
                color: "#333333", // 自定义悬停时的文字颜色
              },
            },
          },
          itemStyle: {
            normal: {
              borderColor: "#E5E5E5", // 分界线颜色
              borderWidth: "2",
              areaColor: "#F0F2F6", // 区域颜色
            },
            emphasis: {
              areaColor: "#D1D3D6", // 自定义悬停时的区域颜色
              borderColor: "#E5E5E5", // 自定义悬停时的边界颜色
              borderWidth: 2,
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              shadowBlur: 20,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        },
        series: [
          {
            type: "scatter",
            coordinateSystem: "geo",
          },
          {
            name: "项目",
            type: "map",
            geoIndex: 0,
            data: [
              {
                name: "北京",
                value: 14,
              },
              {
                name: "天津",
                value: 17,
              },
              {
                name: "上海",
                value: 37,
                office:"上海办事处",
              },
              {
                name: "重庆",
                value: 24,
                office:"重庆办事处",
              },
              {
                name: "河北",
                value:  27,
                office:"保定办事处",
              },
              {
                name: "河南",
                value:  127,
                office:"郑州办事处一处,郑州办事处二处",
              },
              {
                name: "云南",
                value: 15,
                office:"昆明办事处",
              },
              {
                name: "辽宁",
                value: 10,
              },
              {
                name: "黑龙江",
                value: 0,
              },
              {
                name: "湖南",
                value: 119,
                office:"长沙办事处",
              },
              {
                name: "安徽",
                value:  63,
                office:"合肥办事处,芜湖办事处",
              },
              {
                name: "山东",
                value: 100,
                office:"济南办事处",
              },
              {
                name: "新疆",
                value: 0,
              },
              {
                name: "江苏",
                value: 367,
                office:"苏州办事处一处,苏州办事处二处",
              },
              {
                name: "浙江",
                value: 362,
                office:"嘉善办事处,台州办事处",
              },
              {
                name: "江西",
                value: 155,
                office:"南昌办事处",
              },
              {
                name: "湖北",
                value: 47,
                office:"武汉办事处",
              },
              {
                name: "广西",
                value: 63,
                office:"南宁办事处",
              },
              {
                name: "甘肃",
                value: 0,
              },
              {
                name: "山西",
                value: 10,
                office:"太原办事处",
              },
              {
                name: "内蒙古",
                value: 8,
              },
              {
                name: "陕西",
                value: 27,
                office:"西安办事处",
              },
              {
                name: "吉林",
                value: 12,
              },
              {
                name: "福建",
                value: 91,
                office:"厦门办事处",
              },
              {
                name: "贵州",
                value: 28,
                office:"贵阳办事处",
              },
              {
                name: "广东",
                value: 927,
                office:"深圳办事处,东莞办事处,惠州办事处,佛山办事处,肇庆办事处",
              },
              {
                name: "青海",
                value: 14,
                office:"南川办事处",
              },
              {
                name: "西藏",
                value: 0,
              },
              {
                name: "四川",
                value: 41,
                office:"成都办事处",
              },
              {
                name: "宁夏",
                value: 4,
              },
              {
                name: "海南",
                value: 8,
              },
              {
                name: "台湾",
                value: 0,
              },
              {
                name: "香港",
                value: 0,
              },
              {
                name: "澳门",
                value: 0,
              }
            ],
          },
        ],
      };
      chinaMap.setOption(option);
    },
  }
}
</script>

<style scoped lang="scss">
.banner {
  width: 100%;
  height: 5.8rem;
  background: url('../../assets/image/wireless/wirelessBanner.jpg') center no-repeat;
  background-size: cover;
  padding-left: 1.8rem;

  .title {
    font-size: 0.44rem;
    font-weight: 500;
    text-shadow: 0 0.03rem 0.06rem rgba(0, 0, 0, 0.16);
    margin-top: 2.35rem;
    position: relative;
    color: #fff;
    display: inline-block;
  }

  .titleSub {
    content: "NEWS";
    position: absolute;
    margin-top: 2.04rem;
    font-size: 0.44rem;
    font-weight: 500;
    color: rgb(169 160 160 / 51%);
    text-shadow: 0 0.03rem 0.06rem rgba(0, 0, 0, 0.16);
    letter-spacing: 0.02rem;
  }

  .desc {
    font-weight: 400;
    font-size: 0.24rem;
    color: #FFFFFF;
    margin-top: 0.2rem;
    line-height: 0.4rem;
  }
}

.wl-solution{
  margin-top: 1rem;
  .title{
    font-weight: 500;
    font-size: 0.32rem;
    color: #333333;
    text-align: center;
    margin-bottom: 0.7rem;
  }
  .nav{
    display: flex;
    justify-content: center;
    .nav-con{
      width: 15.6rem;
      padding-top: 0.22rem;
      padding-left: 3rem;
      padding-right: 3rem;
      background: #FFFFFF;
      //box-shadow: 0px 0.03rem 0.06rem 0.01px rgba(0,0,0,0.16);
      border-bottom: 0.01rem solid #DBDBDB;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .nav-con-title{
        //margin-left: 0.8rem;
        font-weight: 400;
        font-size: 0.2rem;
        color: #333333;
        padding-bottom: 0.22rem;
      }
      .nav-con-title-active{
        font-weight: 500;
        padding-bottom: 0.21rem;
        border-bottom: 0.01rem solid #000000;
      }
    }
  }
  .content{
    //.solution-pre{
    //  opacity: 1;
    //  transform: translateX(0);
    //}
    //.solution-next{
    //  opacity: 1;
    //  transform: translateX(0);
    //}
    //.solution-active{
    //  opacity: 1;
    //  transform: translateX(0);
    //}
    .first-img{
      //transition: transform 0.5s ease-in-out, opacity 0.5s ease-in-out;
      border-bottom-right-radius:0.2rem;
      border-top-right-radius:0.2rem;
      background-size: cover;
      height: 5.6rem;
      width: 17%;
      background-position: right;
      background-repeat: no-repeat;
      position: relative;
      cursor: pointer;
      .right{
        background: url('../../assets/image/wireless/product-left.png') center no-repeat;
        background-size: cover;
        width: 0.62rem;
        height: 0.62rem;
        position: absolute;
        transform: translate(-50%, -50%);
        top: 50%;
        left: 50%;
      }
      .right:hover{
        background: url('../../assets/image/wireless/product-left-active.png') center no-repeat;
        background-size: cover;
      }
    }
    .second-img{
      transition: transform 0.5s ease-in-out, opacity 0.5s ease-in-out;
      border-radius:0.2rem;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      height: 5.6rem;
      width: calc(66% - 0.2rem);
      cursor: pointer;
    }
    .third-img{
      transition: transform 0.5s ease-in-out, opacity 0.5s ease-in-out;
      position: relative;
      border-bottom-left-radius:0.2rem;
      border-top-left-radius:0.2rem;
      background-position: left;
      background-repeat: no-repeat;
      background-size: cover;
      height: 5.6rem;
      width: 17%;
      cursor: pointer;
      .left{
        background: url('../../assets/image/wireless/product-right.png') center no-repeat;
        background-size: cover;
        width: 0.62rem;
        height: 0.62rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .left:hover{
        background: url('../../assets/image/wireless/product-right-active.png') center no-repeat;
        background-size: cover;
      }
    }
  }
}
.wl-spec{
  margin-top: 0.8rem;
  .nav{
   display: flex;
    justify-content: center;
    .nav-con{
      width: 100%;
      padding-top: 0.22rem;
      background: #FFFFFF;
      box-shadow: 0 0.03rem 0.06rem 0.01rem rgba(0,0,0,0.16);
      display: flex;
      align-items: center;
      justify-content: center;
      .nav-con-title{
        margin-left: 0.8rem;
        font-weight: 400;
        font-size: 0.16rem;
        color: #333333;
        padding-bottom: 0.22rem;
      }
      .nav-con-title:first-child{
        margin-left: 0;
      }
      .nav-con-title-active{
        color: #347DEA;
        padding-bottom: 0.21rem;
        border-bottom: 0.01rem solid #347DEA;
      }
    }
  }
  .content-spec{
    width: 100%;
    background: url('../../assets/image/wireless/wlSpecBg.jpg') center no-repeat;
    background-size: cover;
    padding-top: 1rem;
    padding-bottom: 1rem;
    .title{
      font-weight: 500;
      color: #333333;
      text-align: center;
      font-size: 0.32rem;
      margin: 0 0 0.8rem 0;
    }
    .line{
      display: flex;
      justify-content: center;
      align-items: center;
      .left{
        width: 5.19rem;
        border-radius: 0.08rem;
        padding:0.18rem 0.2rem 0.18rem 0rem;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        background-color: rgba(255, 255, 255, 0.5);
        margin-right: 0.4rem;
        .one{
          font-weight: 500;
          font-size: 0.24rem;
          color: #333333;
          margin-bottom: 0.1rem;
          display: flex;
          align-items: center;
        }
        .two{
          font-weight: 400;
          font-size: 0.16rem;
          color: #666666;
        }
      }
      img{
        width: 1.4142rem;
      }
      .right{
        width: 5.19rem;
        border-radius: 0.08rem;
        padding:0.18rem 0 0.18rem 0.2rem;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        background-color: rgba(255, 255, 255, 0.5);
        margin-left: 0.4rem;
        .one{
          font-weight: 500;
          font-size: 0.24rem;
          color: #333333;
          margin-bottom: 0.1rem;
          display: flex;
          align-items: center;
        }
        .two{
          font-weight: 400;
          font-size: 0.16rem;
          color: #666666;
        }
      }
    }
  }
  .content-mode{
    background: url("../../assets/image/wireless/modeBg.jpg") center no-repeat;
    background-size: cover;
    background-color: #510203;
    padding: 1rem 1.8rem;
    .title{
      font-weight: 500;
      font-size: 0.32rem;
      color: #3B5377;
      text-align: center;
    }
    .secondTitle{
      font-weight: 500;
      font-size: 0.16rem;
      color: #999999;
      text-align: center;
      margin-top: 0.2rem;
      margin-bottom: 0.4rem;
    }
    .data{
      .he{
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 500;
        font-size: 0.23rem;
        color: #FFFFFF;
        border-right: 0.01rem  solid #FFFFFF;
        background: linear-gradient( 180deg, #98A6E8 0%, #2440C4 100%);
      }
      display: flex;
      .row1{
        height: 0.7152rem;
      }
      .row2{
        height: 0.72rem;
        font-size: 0.24rem !important;
        color: #347DEA !important;
        font-weight: 600 !important;
      }
      .row3{
        height: 0.96rem;
      }
      .row4{
        height: 0.96rem;
      }
      .row5{
        height: 0.95rem;
        border-bottom: none !important;
      }
      .rg{
        width: 5.48rem !important;
      }
      .last{
        width: 4.56rem !important;
      }
      .mid{
        background: #FFFFFF;
        width: 3.5rem;
        .con{
          font-weight: 400;
          color: #000000;
          font-size: 0.24rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 0.2rem 0 0.2rem;
          border-bottom: 0.01rem solid #000000;
          border-right: 0.01rem  solid #000000;
        }
      }
      .lf{
        width: 1.96rem;
        //background: linear-gradient( 180deg, #98A6E8 0%, #2440C4 100%);
        .con{

          border-bottom: 0.01rem  solid #FFFFFF;
          display: flex;
          align-items: center;
          padding-left: 0.22rem;
          font-weight: 500;
          font-size: 0.24rem;
          color: #FFFFFF;
        }
      }
    }
  }
  .content-product{
    padding: 1rem 1.8rem 0.85rem 1.8rem;
    .title{
      font-weight: 500;
      font-size: 0.32rem;
      color: #333333;
      text-align: center;
      margin-bottom: 0.6rem;
    }
    .box{
      position: relative;
      .vr{
        position: absolute;
        top: 50%;
        left: 50%;

        background: #999999;
        width: 0.01rem;
        height: 100%;
        transform: translate(-50%, -50%) rotate(20deg);
      }
      .product{
        display: flex;
        justify-content: space-between;
        .soft{
          padding-top: 1.06rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          .line1{
            text-align: center;
            .text1{
              font-weight: 500;
              font-size: 0.24rem;
              color: #333333;
            }
            .text2{
              font-weight: 400;
              font-size: 0.16rem;
              color: #666666;
              display: block;
              margin-top: 0.1rem;
            }
          }
          .line3{
            display: flex;
            align-items: center;
            .productLeft{
              background: url('../../assets/image/wireless/product-left.png') center no-repeat;
              background-size: cover;
              width: 0.48rem;
              height: 0.48rem;
              margin-right: 0.2rem;
              cursor: pointer;
            }
            .productLeft:hover{
              background: url('../../assets/image/wireless/product-left-active.png') center no-repeat;
              background-size: cover;
            }
            .productRight{
              background: url('../../assets/image/wireless/product-right.png') center no-repeat;
              background-size: cover;
              width: 0.48rem;
              height: 0.48rem;
              margin-right: 0.2rem;
              cursor: pointer;
            }
            .productRight:hover{
              background: url('../../assets/image/wireless/product-right-active.png') center no-repeat;
              background-size: cover;
            }
            .item{
              cursor: pointer;
              width: 2rem;
              background: url('../../assets/image/wireless/productBg.png') center no-repeat;
              background-size: cover;
              padding: 0.05rem 0 0.22rem 0;
              margin-right: 0.22rem;
              .top{
                display: flex;
                align-items: center;
                margin-bottom: 0.5rem;
                margin-left: 0.2rem;
                span{
                  font-weight: 400;
                  font-size: 0.24rem;
                  color: #333333;
                }
              }
              img{
               width: 1.16rem
              }
            }
            .item:last-child{
              margin-right: 0;
            }
          }
        }
        .hardware{
          padding-top: 1rem;
          padding-bottom: 1rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          .line2{
            margin-top: 0.4rem;
            text-align: center;
            margin-left: -0.8rem;
            .text1{
              font-weight: 500;
              font-size: 0.24rem;
              color: #333333;
            }
            .text2{
              font-weight: 400;
              font-size: 0.16rem;
              color: #666666;
              margin-top: 0.1rem;
            }

          }
          .line1{
            display: flex;
            align-items: center;
            .productLeft{
              background: url('../../assets/image/wireless/product-left.png') center no-repeat;
              background-size: cover;
              width: 0.48rem;
              height: 0.48rem;
              margin-right: 0.2rem;
              cursor: pointer;
            }
            .productLeft:hover{
              background: url('../../assets/image/wireless/product-left-active.png') center no-repeat;
              background-size: cover;
            }
            .productRight{
              background: url('../../assets/image/wireless/product-right.png') center no-repeat;
              background-size: cover;
              width: 0.48rem;
              height: 0.48rem;
              margin-right: 0.2rem;
              cursor: pointer;
            }
            .productRight:hover{
              background: url('../../assets/image/wireless/product-right-active.png') center no-repeat;
              background-size: cover;
            }
            .item{
              cursor: pointer;
              width: 2rem;
              background: url('../../assets/image/wireless/productBg.png') center no-repeat;
              background-size: cover;
              padding: 0.05rem 0 0.22rem 0;
              margin-right: 0.22rem;
              .top{
                display: flex;
                align-items: center;
                margin-bottom: 0.2rem;
                margin-left: 0.2rem;
                span{
                  font-weight: 400;
                  font-size: 0.24rem;
                  color: #333333;
                }
              }
              img{
                width: 100%;
              }
            }
            .item:last-child{
              margin-right: 0;
            }
          }
        }
      }

    }

  }
  .wl-business{
    padding-top: 1rem;
    .title{
      font-weight: 500;
      font-size: 0.32rem;
      color: #333333;
      text-align: center;
      margin-bottom: 0.7rem;
    }
    .nav1{
      display: flex;
      justify-content: center;
      .nav-con{
        width: 15.6rem;
        padding-top: 0.22rem;
        padding-left: 3.8rem;
        padding-right: 3.8rem;
        background: #FFFFFF;
        //box-shadow: 0px 0.03rem 0.06rem 0.01px rgba(0,0,0,0.16);
        border-bottom: 0.01rem solid #DBDBDB;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .nav-con-title{
          //margin-left: 0.8rem;
          font-weight: 400;
          font-size: 0.2rem;
          color: #333333;
          padding-bottom: 0.22rem;
        }
        .nav-con-title-active{
          font-weight: 500;
          padding-bottom: 0.21rem;
          border-bottom: 0.01rem solid #000000;
        }
      }
    }
    .content{
      margin-top: 0.2rem;
      padding: 1rem 1.8rem;
      background: #F2F7FE;
      .top{
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        .left{
          width: calc((100% - 0.4rem) / 2);
          .title{
            font-weight: 500;
            font-size: 0.24rem;
            color: #333333;
            text-align: start;
            margin-bottom: 0.4rem;
          }
          .desc{
            font-weight: 400;
            font-size: 0.16rem;
            color: #333333;
            line-height: 0.3rem;
            margin-bottom: 0.4rem;
            //width: 6.7rem;
          }
          .point-con-list{
            .con{
              display: flex;
              position: relative; /* 相对定位 */
              padding-left: 0.2rem; /* 圆点的宽度加上间距 */
              margin-bottom: 0.2rem;
              line-height: 0.3rem;
              .icon{
                position: absolute; /* 绝对定位 */
                left: 0; /* 相对于 .list-item 左侧对齐 */
                //transform: translateY(-50%); /* 垂直居中 */
                width: 0.1rem; /* 圆点的直径 */
                height: 0.1rem;
                background-color: #FEF100; /* 圆点的颜色 */
                border-radius: 50%; /* 将正方形变成圆形 */
                margin-right: 0.1rem; /* 圆点和文字之间的间距 */
                margin-top: 0.1rem;

              }
              .text{

                .title1{

                  font-size:.16rem;
                  color: #333333;
                  font-weight: 500;
                  text-align: start;
                }
                .desc1{
                  text-align: start;
                  font-size: 0.16rem;
                }
              }
            }
            .con:last-child{
              margin-bottom: 0;
            }
          }
        }
        .right{
          width: calc((100% - 0.4rem) / 2);
          height: 3.85rem;
          background: url('../../assets/image/wireless/businessSBg.jpg') center no-repeat;
          background-size: cover;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .bot{
        margin-top: 0.4rem;

        .line1{
          font-weight: 400;
          font-size: 0.24rem !important;
          color: #333333;
          margin-bottom: 0.4rem;
        }
        .list{
          display: flex;
          justify-content: space-between;
          align-items: center;
          .item{
            width: calc((100% - 0.4rem) / 2);
            display: flex;
            img{
              width: 2.41rem;
              height: 2.67rem;
              border-bottom-left-radius: 0.1rem;
              border-top-left-radius: 0.1rem;
            }
            .con{
              padding: 0.4rem 0.4rem 0 0.4rem;
              background: white;
              border-bottom-right-radius: 0.1rem;
              border-top-right-radius: 0.1rem;
              .title{
                font-weight: 500;
                font-size: 0.18rem;
                color: #333333;
                text-align: start;
                margin-bottom: 0.2rem;
              }
              .desc{
                font-weight: 400;
                font-size: 0.14rem;
                color: #333333;
                line-height: 0.3rem;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
                width: 4.34rem;
              }
              .more{
                background: url('../../assets/image/wireless/more-icon.png') center no-repeat;
                background-size: cover;
                width: 1.4rem;
                height: 0.42rem;
                font-weight: 400;
                font-size: 0.16rem;
                color: #333333;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-top: 0.2rem;
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }

}
.managingPatientSize {
  padding: 1rem 0 0 0;
  .data{
    padding: 0.8rem 2.83rem 0 2.83rem;
    display: flex;
    justify-content: space-between;
    .item{
      //width: 2.83rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      .line1{
        display: flex;
        align-items: baseline;
        padding: 0 0.35rem 0.2rem 0.35rem;
        border-bottom: 0.01rem solid #999999;;
        img{
          width: 0.4rem;
        }
        .number{
          font-family: DIN Condensed, DIN Condensed;
          font-weight: bold;
          font-size: 0.54rem;
          color: #000000;
          margin-left: 0.2rem;
          margin-right: 0.1rem;
        }
        .text{
          font-size: 0.26rem;
          color: #333333;
          font-weight: 500;
        }

      }
      .line2{
        font-weight: 400;
        font-size: 0.2rem;
        color: #333333;
        margin-top: 0.2rem;
      }
    }
  }
  .hr2 {
    width: 8.82rem;
    //border-top: none;
    //border-right: none;
    //border-left: none;
    //box-shadow: 0 .02rem .02rem .02rem rgba(0, 0, 0, .16);

    margin-top: 0.76rem;
    border-bottom: 0.02rem solid rgba(0, 0, 0, 0.1); /* 下边框 */
    box-shadow: 0 0.01rem 0.03rem rgba(0, 0, 0, 0.16); /* 下边框阴影 */
    margin-bottom: -0.3rem;
  }
  .title{
    font-weight: 500;
    font-size:0.32rem;
    color: #333333;
    text-align: center;
  }
  background: url('../../assets/image/wireless/mapBg.png') center no-repeat;
  background-size: cover;
  color: #fff;
  .el-row {
    height: 100%;
    .el-col {
      height: 100%;
      #china-map {
        height: 6.5rem
      }
    }
  }
}
.customer-title{
  font-weight: 500;
  font-size: 0.32rem;
  color: #333333;
  text-align: center;
  margin: 0.12rem 0 0.8rem 0;
}
.scroll-container {
  position: relative;
  width: 100%;
  overflow:hidden;
  display: flex;
  align-items: center;
  overflow: hidden;
  mask-image: linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 10%, rgb(0, 0, 0) 90%, rgba(0, 0, 0, 0) 100%);
  -webkit-mask-image: linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 10%, rgb(0, 0, 0) 90%, rgba(0, 0, 0, 0) 100%);
}
.wl-chuangxin{
  background: url('../../assets/image/wireless/wlCxBg.jpg') center no-repeat;
  background-size: cover;
  padding: 1rem 2.8rem 0 2.8rem;
  .title{
    font-weight: 500;
    font-size: 0.32rem;
    color: #FFFFFF;
    text-align: center;
  }
  .box{
    display: flex;
    justify-content: space-between;
    .det:hover{
      .bot{
        display: block;
      }
      margin-top: -1rem;
      .top{
        .title{
          display: none;
        }
      }
    }
    .det{
      padding-top: 1.8rem;
      padding-bottom: 1rem;
      cursor: pointer;
      width: 25%;
      .top{
        .title{
          font-weight: 500;
          font-size: 0.24rem;
          color: #FEF100;
          margin-bottom: 0.2rem;
        }
      }
      .bot{
        height: 4.85rem;
        display: none;
        background: linear-gradient( 149deg, #FEF100 0%, #DBE002 40%, #FEF100 100%);
        padding: 0.4rem 0.4rem 1rem 0.4rem;
        border-radius: 0.1rem;
        .title{
          font-weight: 500;
          font-size: 0.24rem;
          color: #333333;
          padding-bottom: 0.4rem;
          border-bottom: 0.01rem solid #707070;
          margin-bottom: 0.4rem;
        }
        .desc{
          font-weight: 400;
          font-size: 0.16rem;
          color: #333333;
          line-height: 0.3rem;
        }
      }
    }
  }
}

.scroll-content-wrapper {
  display: flex;
  animation: scroll-right 60s linear infinite;
}

.scroll-content-wrapper-second {
  display: flex;
  animation: scroll-left 60s linear infinite;
}

.scroll-content-wrapper:hover, .scroll-content-wrapper-second:hover{
  animation-play-state: paused;
}


.scroll-content {
  img{
    width: 100%;
  }
  position: relative;
  flex: none;
  width: 2.3rem;
  height: 1.2rem;
  /* height: 200px; */
  /*  background-color: lightblue; */
  margin-right: 0.2rem; /* Space between elements */
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5em;
  overflow: hidden; /* Ensure content doesn't overflow */
  text-align: center; /* Center text horizontally */
  border: 0.01rem solid #f0f0f0;
}
.more-info {
  display: none; /* Initially hide the more-info div */
  position: absolute;
  top: 50%; /* Align to the center vertically */
  left: 50%; /* Align to the center horizontally */
  transform: translate(-50%, -50%);
  background-color: rgba(255, 255, 255, 0.8); /* Semi-transparent white background */
  padding: 0.1rem 0.2rem; /* Padding for the button */
  cursor: pointer; /* Change cursor to pointer on hover */
  z-index: 1; /* Ensure it's above the scroll-content */
  background-color: #00AA72;
  font-size: 0.14rem;
  color: #FFF;
}

.scroll-content:hover .more-info {
  display: block; /* Show more-info on hover */
}


.scroll-content:hover::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  //background-color: white;
  opacity: 0.8; /* Adjust opacity as needed */
}

@keyframes scroll-left {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}
@keyframes scroll-right {
  0% {
    transform: translateX(-50%);
  }
  100% {
    transform: translateX(0%);
  }
}


</style>



// WEBPACK FOOTER //
// src/pages/wireless/wireless.vue